import {
  EMBED_OWNER_INFO_CLICK,
  EMBED_TITLE_CLICK,
  EMBED_WATCH_ON_LOOM_CLICK,
} from 'constants/events';
import * as analytics from 'utilities/analytics';

export const onTitleClick = props =>
  analytics.track(EMBED_TITLE_CLICK, {
    from_link_expand: props.fromLinkExpand,
    parent_location: props.parentLocation,
    video_id: props.videoModel.id,
    title: props.videoName,
  });

export const onOwnerClick = props =>
  analytics.track(EMBED_OWNER_INFO_CLICK, {
    from_link_expand: props.fromLinkExpand,
    parent_location: props.parentLocation,
    video_id: props.videoModel.id,
  });

export const watchOnLoomClick = props =>
  analytics.track(EMBED_WATCH_ON_LOOM_CLICK, {
    from_link_expand: props.fromLinkExpand,
    parent_location: props.parentLocation,
    video_id: props.videoModel.id,
  });
